import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Label, ButtonToolbar, Button } from 'reactstrap';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import { green, yellow, red } from '@material-ui/core/colors';
import DateField from '../../../shared/components/form/DateField';
import Select from '../../../shared/components/form/Select';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';

const AppoitmentFilter = (props) => {
  const {
    t,
    itens,
    students,
    employees,
    classes,
    filterClick,
    initialize,
    lastFilter,
  } = props;

  const [filter, setFilter] = useState({
    initialDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0,
      0,
      0
    ),
    finalDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0,
      0,
      0
    ),
    normalSinc: true,
    regularSinc: true,
    badSinc: true,
  });
  const filterChange = (field, value) => {
    const updatedFilter = { ...filter };
    updatedFilter[field] = value;
    setFilter(updatedFilter);
  };

  const filterNormalSincCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('normalSinc', evt.target.checked);
    } else {
      filterChange('normalSinc', true);
    }
  };

  const filterRegularSincCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('regularSinc', evt.target.checked);
    }
  };
  const filterBadSincCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('badSinc', evt.target.checked);
    }
  };

  useEffect(() => {
    if (lastFilter) {
      setFilter(lastFilter);
      initialize(lastFilter);
    } else {
      initialize(filter);
    }
  }, []);

  return (
    <Fragment>
      <form className="form">
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                value={filter.initialDate}
                onChange={(value) => filterChange('initialDate', value)}
                maxDate={new Date().now}
                placeholder={t('general.initial_date')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                value={filter.finalDate}
                minDate={filter.initialDate}
                maxDate={new Date().now}
                onChange={(value) => filterChange('finalDate', value)}
                placeholder={t('general.final_date')}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.itens')}</span>
          <div className="form__form-group-field">
            <Field
              name="itens"
              type="text"
              component={Select}
              isMulti
              closeMenuOnSelect={false}
              placeholder={t('general.itens')}
              options={itens}
              onChange={(values) => filterChange('itens', values)}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="classes"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              options={classes}
              onChange={(values) => filterChange('classes', values)}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="students"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              options={students}
              onChange={(values) => filterChange('students', values)}
              placeholder={t('general.students')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.employees')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="employees"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              options={employees}
              onChange={(values) => filterChange('employees', values)}
              placeholder={t('general.employees')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_appointment.synchronization_time.title')}
          </span>
        </div>
        <div className="form__form-group--3_columns">
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="normalSinc"
                component={renderCheckBoxField}
                className="colored-click"
                onChange={filterNormalSincCheckChange}
                checked={filter.normalSinc}
              />
              <Label
                style={{ paddingRight: '5px' }}
                className="form__form-group-label"
              >
                {t('mnt_appointment.synchronization_time.less-than-1-hour')}
              </Label>
              <span
                className="tooltip-test"
                title={t(
                  'mnt_appointment.synchronization_time.less-than-1-hour'
                )}
              >
                <AccessTimeOutlinedIcon style={{ color: green[500] }} />
              </span>
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="regularSinc"
                component={renderCheckBoxField}
                defaultValue
                className="colored-click"
                checked={filter.regularSinc}
                onChange={filterRegularSincCheckChange}
              />
              <Label
                style={{ paddingRight: '5px' }}
                className="form__form-group-label"
              >
                {t(
                  'mnt_appointment.synchronization_time.between-1-and-4-hours'
                )}
              </Label>
              <span
                className="tooltip-test"
                title={t(
                  'mnt_appointment.synchronization_time.between-1-and-4-hours'
                )}
              >
                <AccessTimeOutlinedIcon style={{ color: yellow[700] }} />
              </span>
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="badSinc"
                component={renderCheckBoxField}
                className="colored-click"
                checked={filter.badSinc}
                onChange={filterBadSincCheckChange}
              />
              <Label
                style={{ paddingRight: '5px' }}
                className="form__form-group-label"
              >
                {t('mnt_appointment.synchronization_time.more-than-4-hours')}
              </Label>
              <span
                className="tooltip-test"
                title={t(
                  'mnt_appointment.synchronization_time.more-than-4-hours'
                )}
              >
                <AccessTimeOutlinedIcon style={{ color: red[500] }} />
              </span>
            </div>
          </div>
          <ButtonToolbar className="filter-button">
            <Button color="success" onClick={() => filterClick(filter)}>
              {t('general.filter')}
            </Button>
          </ButtonToolbar>
        </div>
      </form>
    </Fragment>
  );
};

AppoitmentFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  itens: PropTypes.arrayOf(PropTypes.shape).isRequired,
  students: PropTypes.arrayOf(PropTypes.shape).isRequired,
  employees: PropTypes.arrayOf(PropTypes.shape).isRequired,
  classes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  lastFilter: PropTypes.shape(PropTypes.shape),
};

AppoitmentFilter.defaultProps = {
  lastFilter: null,
};

export default reduxForm({
  form: 'AppoitmentFilter',
})(withTranslation('common')(AppoitmentFilter));
